export const COOKIE_KEYS = [
    'refreshToken',
    'username',
    'expiresIn',
    'timeOutStamp',
    'customerSessionId',
  ];
